var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Facebook_svg__a",
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.704
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Facebook_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Facebook_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.17 0C29.36 0 30 .64 30 8.83v12.34c0 8.19-.64 8.83-8.83 8.83h-1.567V19.079h3.85l.606-4.328h-4.456s-.007-2.534 0-3.166c.013-1.236 1.045-1.862 1.933-1.853.888.01 2.726.003 2.726.003V5.747S22.67 5.541 21 5.523c-1.403-.014-2.953.365-4.204 1.626-1.27 1.282-1.472 3.19-1.496 5.523-.007.674 0 2.078 0 2.078h-3.768v4.328H15.3V30H8.83C.64 30 0 29.36 0 21.17V8.83C0 .64.64 0 8.83 0z",
    mask: "url(#Facebook_svg__b)"
  }))));
};
export default SvgFacebook;